module.exports = __webpack_public_path__ + "img/bg_10@2x.856b9a4c.png";